import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle, ArrowLeft, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { hasAnalyticsConsent } from "@/hooks/useCookieConsent";
import SEO from "@/components/marketing/SEO";
import Header from "@/components/marketing/Header";
import Footer from "@/components/marketing/Footer";

const ThankYou = () => {
  // Track Meta Pixel CompleteRegistration event on page load (only if consent granted)
  useEffect(() => {
    if (typeof window.fbq === 'function' && hasAnalyticsConsent()) {
      window.fbq('track', 'CompleteRegistration', {
        content_name: 'Demo Request Completed',
        status: 'submitted',
      });
    }
  }, []);

  return (
    <>
      <SEO
        title="Merci pour votre demande | Piktable"
        description="Votre demande a été envoyée avec succès. Nous vous contacterons rapidement pour démarrer votre essai gratuit avec Piktable."
        canonical="/merci"
      />
      <Header />
      <main className="min-h-screen bg-background pt-24 pb-16 flex items-center">
        <div className="container mx-auto px-4 max-w-2xl text-center">
          <div className="bg-card border border-border rounded-xl p-8 md:p-12 shadow-sm">
            <div className="flex justify-center mb-6">
              <div className="h-20 w-20 rounded-full bg-green-100 flex items-center justify-center">
                <CheckCircle className="h-10 w-10 text-green-600" />
              </div>
            </div>

            <h1 className="font-playfair text-3xl md:text-4xl font-bold text-foreground mb-4">
              Merci pour votre demande !
            </h1>

            <p className="text-muted-foreground text-lg mb-6">
              Votre demande a bien été envoyée. Vous allez recevoir un email de confirmation dans les prochaines minutes.
            </p>

            <div className="bg-muted/50 rounded-lg p-6 mb-8">
              <h2 className="font-semibold text-foreground mb-2">
                Que se passe-t-il ensuite ?
              </h2>
              <ul className="text-muted-foreground text-left space-y-2">
                <li className="flex items-start gap-2">
                  <span className="text-primary font-bold">1.</span>
                  Vous recevez un email de confirmation
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary font-bold">2.</span>
                  Notre équipe vous contacte sous 24h
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary font-bold">3.</span>
                  Vous démarrez votre premier mois gratuit
                </li>
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild variant="outline">
                <Link to="/">
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Retour à l'accueil
                </Link>
              </Button>
              <Button asChild>
                <a 
                  href="https://calendly.com/maxdmnt/piktable" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Calendar className="mr-2 h-4 w-4" />
                  Planifier un appel maintenant
                </a>
              </Button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ThankYou;